import React from 'react';
import { connect } from "react-redux";
import { withRouter } from '../_helpers/withRouter';
import { RelatorioFazendaLogSinc } from './relatorioFazendaLogSinc.component'
import { RelatorioFazendaLogSincFinanceiro } from './relatorioFazendaLogSincFinanceiro.component'
import { Container, Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import NavBar from '../_components/navbar';
import { RelatorioLogErroNfe } from './relatorioLogErroNfe.component';
import { RelatorioLogErroGeral } from './relatorioLogErroGeral.component';

const RelatorioLog = (props) => {

    return (
        <div>
            <NavBar {...props} />
            <Container>
                <Row style={{ marginTop: 10, marginBottom: 10, justifyContent: 'center', textAlign: 'center' }}>
                    <h5 className="center">Relatório de Logs</h5>
                </Row>
                <Row style={{ marginTop: 10 }}>
                    <Col md={12}>
                        <RelatorioFazendaLogSinc />
                    </Col>
                </Row>
                <Row style={{ marginTop: 15 }}>
                    <Col md={12}>
                        <RelatorioFazendaLogSincFinanceiro />
                    </Col>
                </Row>
                <Row style={{ marginTop: 15 }}>
                    <Col md={12}>
                        <RelatorioLogErroNfe />
                    </Col>
                </Row>
                <Row style={{ marginTop: 15 }}>
                    <Col md={12}>
                        <RelatorioLogErroGeral />
                    </Col>
                </Row>
            </Container>
            
        </div >
    );
}


const mapStateToProps = (state) => {
    return state
};

const connectedRelatorioLogPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(RelatorioLog));
export { connectedRelatorioLogPage as RelatorioLog };